export default {
  credential: 'مدرک',
  editCredential: 'ویرایش مدرک',
  deleteCredential: 'حذف مدرک',
  addCredential: 'افزودن مدرک',
  credentialType: 'نوع مدرک',
  credentialFrontImage: 'تصویر روی مدرک',
  credentialBackImage: 'تصویر پشت مدرک',
  credentialCreatedSuccessfully: 'مدرک با موفقیت افزوده شد',
  confirmed: 'تایید شده',
  awaitingConfirmation: 'در انتظار تایید'
}
